import { useRef, useEffect } from 'react';

export default function useLatestRefValue(value) {
  const valueRef = useRef(value);

  useEffect(() => {
    valueRef.current = value;
  }, [value]);

  return valueRef;
}
